import { DealerId } from '@upstart/harmony/lib/legos/dealerTypes';
import BackendService from './BackendService';

export default class DTEntitiesService {
  static getDealerDTEntities(dealerId: DealerId): Promise<any[]> {
    if (!dealerId) {
      throw new Error('No dealer to get DTEntities for');
    }

    return BackendService.get(`/dms/internal/dte/${dealerId}`);
  }
}
